module.exports = __webpack_public_path__ + "static/media/intro-headline.eca046e8.svg";